import Photo from "./Photo.class";

const Album = (props) => {
    return {
      name: props.name,
      photos: props.photos.map(p => Photo(p))
    };
  };
  
  export default Album;